import React from 'react';
import insane from 'insane';
import { isBlank } from 'helpers/verify';
import { marked } from './marked';

/*
  Here, we override renderers for markdown tokens we do not want to support.

  See https://github.com/markedjs/marked/blob/master/docs/USING_PRO.md for the full list of
  token renderers, and their arguments.
*/

const renderer = new marked.Renderer();

/* Block Level */
renderer.code = () => '';
renderer.blockquote = () => '';
renderer.html = () => '';
renderer.heading = () => '';
renderer.hr = () => '';
renderer.table = () => '';
renderer.tablerow = () => '';
renderer.tablecell = () => '';
renderer.paragraph = text => text; // Let the consumer decide what to do with newlines and/or paragraphs

/* Inline Level */
renderer.codespan = () => '';
const linkRenderer = renderer.link;
renderer.link = (...args) => {
  const html = linkRenderer.call(renderer, ...args);
  return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
};
renderer.image = () => '';

const options = {
  renderer,
  smartypants: true,
};

const cache = new Map();
export const resetMarkdownCache = key => (key ? cache.delete(key) : cache.clear());

const runParser = md => marked(insane(md, { allowedTags: [] }), options);

const parseMarkdown = (md, key) => {
  if (__SERVER__) {
    // We don't cache markdown renders on the server,
    // since Map is shared across requests.
    return runParser(md);
  }

  if (key && cache.has(key)) {
    return cache.get(key);
  }

  const parsed = runParser(md);

  if (key) {
    cache.set(key, parsed);
  }

  return parsed;
};

// This data is controlled by us, so we can "safely" use dangerouslySet here.
// eslint-disable-next-line react/no-danger
export const renderMarkdown = (md, key) =>
  typeof md === 'string' && !isBlank(md) ? <span dangerouslySetInnerHTML={{ __html: parseMarkdown(md, key) }} /> : null;
